import { HandleTextChange, HandleSelectChange, CallAPI, GetCookieFunction, AgeToBirthday } from '../../utils/util';
import React, { Component } from "react";
import {useLocation, useNavigate, useParams, useSearchParams } from "react-router-dom";
import Alert from 'react-bootstrap/Alert';

function withRouter(Component) {
    function ComponentWithRouterProp(props) {
        let location = useLocation();
        let navigate = useNavigate();
        let params = useParams();
        let [searchParams] = useSearchParams();

        return (
            <Component
                {...props}
                router={{ location, navigate, params, searchParams }}
            />
        );
    }
    return ComponentWithRouterProp;
}

class RegistrationInfo extends Component {
    constructor(props) {
        super(props);
        this.state = {
            "fName": "",
            "lName": "",
            "gender": "MALE",
            "pNum": "",
            "email": "",
            "bDay": "",
            "address1": "",
            "address2": "",
            "city": "",
            "district": "",
            "City_District_Id": null,
            "type": "patient",
            "timezone": "Asia/Dhaka",
            "centerID": GetCookieFunction("Center").id,
            "centers": [],
            "modalVariant": "",
            "modalMessage": "",
            "citySuggestions": [],
            "showCitySuggestions": false,
            "showAddCityModal": false,
            "newLocation": { city: '', district: '' },
            "addCityModalError": "",
            "age": ""
        };

        // Is this page being access as a funnel mode?
        this.funnel = this.props.router.searchParams.get('funnel') ? "?funnel=1" : "";

        this.handleTextChange = HandleTextChange.bind(this);
        this.handleSelectChange = HandleSelectChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleCityChange = this.handleCityChange.bind(this);
        this.selectLocation = this.selectLocation.bind(this);
    }

    componentDidMount() {
        const currentCenterId = parseInt(GetCookieFunction("Center").id);
        CallAPI({}, "centers/list", 'GET', (res) => {
            const sorted = (res || []).sort((a, b) => {
                if (a.centerID === currentCenterId) return -1;
                if (b.centerID === currentCenterId) return 1;
                return a.centerID - b.centerID;
            });
            this.setState({ centers: sorted });
        });
    }

    handleCityChange(e) {
        const value = e.target.value;
        this.setState({ "city": value });

        if (value.length >= 2) {
            CallAPI({}, `cityDistricts?search=${encodeURIComponent(value)}`, 'GET', (res) => {
                this.setState({
                    "citySuggestions": res.data || [],
                    "showCitySuggestions": true
                });
            });
        } else {
            this.setState({ "citySuggestions": [], "showCitySuggestions": false, "district": "", "City_District_Id": null });
        }
    }

    selectLocation(location) {
        this.setState({
            "City_District_Id": location.id,
            "city": location.city,
            "district": location.district,
            "citySuggestions": [],
            "showCitySuggestions": false
        });
    }

    // Age is the user-facing field; we store the derived Date of Birth (Jan 1 anchor) in bDay.
    handleAgeChange = (e) => {
        const age = e.target.value;
        this.setState({ age, bDay: AgeToBirthday(age) });
    }

    openAddCityModal = () => {
        this.setState({
            showAddCityModal: true,
            showCitySuggestions: false,
            newLocation: { city: this.state.city, district: '' },
            addCityModalError: ''
        });
    }

    closeAddCityModal = () => {
        this.setState({ showAddCityModal: false, addCityModalError: '' });
    }

    handleNewLocationChange = (e) => {
        const { name, value } = e.target;
        this.setState(prev => ({
            newLocation: { ...prev.newLocation, [name]: value }
        }));
    }

    saveNewLocation = (e) => {
        e.preventDefault();
        const { city, district } = this.state.newLocation;

        CallAPI({ city, district }, 'cityDistricts', 'POST', (res) => {
            if (res.success) {
                this.setState({
                    showAddCityModal: false,
                    addCityModalError: '',
                    City_District_Id: res.data.id,
                    city: res.data.city,
                    district: res.data.district
                });
            } else {
                this.setState({ addCityModalError: res.message || "This city/district already exists" });
            }
        }, () => {
            this.setState({ addCityModalError: "Failed to save. Please try again." });
        });
    }

    handleSubmit(event) {
        event.preventDefault();
        
        CallAPI(this.state, "users/create", 'POST', (res) => {
            if (res && res.length > 0 && res[0].success){
                //SetCookieFunction({name: "Patient_ID", value: res[0].patient_id});
                this.props.router.navigate("/patients/"+res[0].patient_id+"/patientInfo"+this.funnel)
            } else {
                this.setState({
                    "modalVariant": "danger",
                    "modalMessage": "The patient record could not be created" + (res[0].message ? ": " + res[0].message : "")
                });
            }
        },
        (resp) => {
            this.setState({
                "modalVariant": "danger",
                "modalMessage": "The patient record could not be created" + (resp.message ? ": " + resp.message : "")
            });
        });
    }

    render = () => {
        return (
            <div className="ci-page">
                <div className="ci-header">
                    <h2>Register New Patient</h2>
                    <p>Enter the patient's personal and contact information</p>
                </div>

                {this.state.modalVariant && (
                    <Alert variant={this.state.modalVariant} className="ci-alert">{this.state.modalMessage}</Alert>
                )}

                <form onSubmit={(e) => this.handleSubmit(e)}>
                    <div className="ci-section-title">Center Assignment</div>
                    <div className="ci-card">
                        <div className="ci-field">
                            <label htmlFor="centerID" className="ci-required-label">Center</label>
                            <select id="centerID" name="centerID" required
                                value={this.state.centerID}
                                onChange={(e) => this.handleSelectChange(e)}>
                                {this.state.centers.map(c => (
                                    <option key={c.centerID} value={c.centerID}>{c.centerName}</option>
                                ))}
                            </select>
                        </div>
                    </div>

                    <div className="ci-section-title">Personal Details</div>
                    <div className="ci-card">
                        <div className="ci-grid">
                            <div className="ci-field">
                                <label htmlFor="fName" className="ci-required-label">First Name</label>
                                <input type="text" id="fName" name="fName" required maxLength="32"
                                    placeholder="First name"
                                    onChange={(e) => this.handleTextChange(e)} />
                            </div>
                            <div className="ci-field">
                                <label htmlFor="lName" className="ci-required-label">Last Name</label>
                                <input type="text" id="lName" name="lName" required maxLength="32"
                                    placeholder="Last name"
                                    onChange={(e) => this.handleTextChange(e)} />
                            </div>
                            <div className="ci-field">
                                <label htmlFor="gender" className="ci-required-label">Gender</label>
                                <select id="gender" name="gender" required onChange={(e) => this.handleSelectChange(e)}>
                                    <option value="MALE">Male</option>
                                    <option value="FEMALE">Female</option>
                                    <option value="OTHER">Other</option>
                                </select>
                            </div>
                            <div className="ci-field">
                                <label htmlFor="age" className="ci-required-label">Age (years)</label>
                                <input type="number" id="age" name="age" required
                                    min="0" max="150" step="1"
                                    placeholder="e.g. 55"
                                    value={this.state.age}
                                    onChange={(e) => this.handleAgeChange(e)} />
                            </div>
                            <div className="ci-field">
                                <label htmlFor="timezone" className="ci-required-label">Time Zone</label>
                                <select id="timezone" name="timezone" required onChange={(e) => this.handleSelectChange(e)}>
                                    <option value="Asia/Dhaka">Asia/Dhaka</option>
                                    <option value="America/Los_Angeles">America/Los Angeles</option>
                                    <option value="America/Phoenix">America/Phoenix</option>
                                    <option value="America/Denver">America/Denver</option>
                                    <option value="America/New_York">America/New York</option>
                                </select>
                            </div>
                        </div>
                    </div>

                    <div className="ci-section-title">Contact Information</div>
                    <div className="ci-card">
                        <div className="ci-grid">
                            <div className="ci-field">
                                <label htmlFor="pNum" className="ci-required-label">Phone Number</label>
                                <input type="tel" id="pNum" name="pNum" required
                                    pattern="^\+?[\d\s\(\)\-]+\d{4}$" maxLength="20"
                                    title="e.g. 01054 694200 or +880 1054 694200"
                                    placeholder="e.g. 01054 694200"
                                    onChange={(e) => this.handleTextChange(e)} />
                            </div>
                            <div className="ci-field">
                                <label htmlFor="email">Email</label>
                                <input type="email" id="email" name="email"
                                    placeholder="email@example.com"
                                    onChange={(e) => this.handleTextChange(e)} />
                            </div>
                        </div>
                    </div>

                    <div className="ci-section-title">Address</div>
                    <div className="ci-card">
                        <div className="ci-grid">
                            <div className="ci-field">
                                <label htmlFor="address1" className="ci-required-label">Address Line 1</label>
                                <input type="text" id="address1" name="address1" required maxLength="100"
                                    placeholder="Street address"
                                    onChange={(e) => this.handleTextChange(e)} />
                            </div>
                            <div className="ci-field">
                                <label htmlFor="address2">Address Line 2</label>
                                <input type="text" id="address2" name="address2" maxLength="100"
                                    placeholder="Apt, suite, etc. (optional)"
                                    onChange={(e) => this.handleTextChange(e)} />
                            </div>
                            <div className="ci-field ci-field-autocomplete">
                                <label htmlFor="city">City</label>
                                <input type="text" id="city" name="city" maxLength="32"
                                    placeholder="City"
                                    autoComplete="off"
                                    value={this.state.city}
                                    onChange={(e) => this.handleCityChange(e)}
                                    onBlur={() => setTimeout(() => this.setState({ showCitySuggestions: false }), 200)} />
                                {this.state.showCitySuggestions && (
                                    <ul className="ci-autocomplete-list">
                                        {this.state.citySuggestions.length > 0 ? (
                                            this.state.citySuggestions.map((loc) => (
                                                <li key={loc.id} className="ci-autocomplete-item"
                                                    onMouseDown={() => this.selectLocation(loc)}>
                                                    {loc.city} — {loc.district}
                                                </li>
                                            ))
                                        ) : (
                                            <li className="ci-autocomplete-item ci-autocomplete-add"
                                                onMouseDown={this.openAddCityModal}>
                                                + Add new city/district
                                            </li>
                                        )}
                                    </ul>
                                )}
                            </div>
                            <div className="ci-field">
                                <label htmlFor="district">District</label>
                                <input type="text" id="district" name="district" maxLength="32"
                                    placeholder="District"
                                    value={this.state.district}
                                    readOnly />
                            </div>
                        </div>
                    </div>

                    <div className="ci-submit-row">
                        <button type="submit" className="logSubmit ci-submit-btn">Next →</button>
                    </div>
                </form>

                {/* ── Add City/District Modal ── */}
                {this.state.showAddCityModal && (
                    <div className="ci-modal-overlay" onClick={this.closeAddCityModal}>
                        <div className="ci-modal" onClick={(e) => e.stopPropagation()}>
                            <h3>Add New City/District</h3>
                            {this.state.addCityModalError ? (
                                <div>
                                    <p className="ci-modal-error">{this.state.addCityModalError}</p>
                                    <div className="ci-submit-row">
                                        <button type="button" className="ci-modal-icon-btn ci-modal-cancel" onClick={this.closeAddCityModal} title="Close">✕</button>
                                    </div>
                                </div>
                            ) : (
                                <form onSubmit={this.saveNewLocation}>
                                    <div className="ci-field">
                                        <label>City</label>
                                        <input type="text" name="city" required maxLength="45"
                                            value={this.state.newLocation.city}
                                            onChange={this.handleNewLocationChange} />
                                    </div>
                                    <div className="ci-field">
                                        <label>District</label>
                                        <input type="text" name="district" required maxLength="45"
                                            value={this.state.newLocation.district}
                                            onChange={this.handleNewLocationChange} />
                                    </div>
                                    <div className="ci-submit-row">
                                        <button type="button" className="ci-modal-icon-btn ci-modal-cancel" onClick={this.closeAddCityModal} title="Cancel">✕</button>
                                        <button type="submit" className="ci-modal-icon-btn ci-modal-save" title="Save">✓</button>
                                    </div>
                                </form>
                            )}
                        </div>
                    </div>
                )}

            </div>
        );
    };
}

export default withRouter(RegistrationInfo)